var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_160_5803)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7931 49.7269C48.577 49.5924 48.3302 49.5151 48.076 49.5023C47.8218 49.4895 47.5685 49.5416 47.34 49.6538L43.3612 51.6019C43.1701 50.9926 42.7895 50.4603 42.2749 50.0822C41.7603 49.7042 41.1385 49.5002 40.5 49.5H30C29.2044 49.5 28.4413 49.8161 27.8787 50.3787C27.3161 50.9413 27 51.7044 27 52.5V60C27 60.7957 27.3161 61.5587 27.8787 62.1213C28.4413 62.6839 29.2044 63 30 63H40.5C41.1602 62.9993 41.8017 62.7808 42.3251 62.3784C42.8485 61.976 43.2246 61.4122 43.395 60.7744L47.3025 62.8369C47.5318 62.9573 47.7883 63.0163 48.0472 63.0082C48.306 63 48.5584 62.925 48.7796 62.7904C49.0009 62.6558 49.1835 62.4662 49.3098 62.2401C49.436 62.0139 49.5015 61.759 49.5 61.5V51C49.5 50.7452 49.4351 50.4946 49.3114 50.2719C49.1877 50.0492 49.0094 49.8616 48.7931 49.7269ZM40.5 60H30V52.5H40.5V58.3125C40.5 58.3369 40.5 58.3594 40.5 58.3838V60ZM46.5 59.0175L43.5 57.4387V54.8738L46.5 53.4056V59.0175ZM61.0612 36.4388L50.5613 25.9388C50.4218 25.7995 50.2564 25.6891 50.0743 25.6138C49.8922 25.5385 49.697 25.4998 49.5 25.5H31.5C30.7044 25.5 29.9413 25.8161 29.3787 26.3787C28.8161 26.9413 28.5 27.7044 28.5 28.5V45C28.5 45.3978 28.658 45.7794 28.9393 46.0607C29.2206 46.342 29.6022 46.5 30 46.5C30.3978 46.5 30.7794 46.342 31.0607 46.0607C31.342 45.7794 31.5 45.3978 31.5 45V28.5H48V37.5C48 37.8978 48.158 38.2794 48.4393 38.5607C48.7206 38.842 49.1022 39 49.5 39H58.5V61.5H54C53.6022 61.5 53.2206 61.658 52.9393 61.9393C52.658 62.2206 52.5 62.6022 52.5 63C52.5 63.3978 52.658 63.7794 52.9393 64.0607C53.2206 64.342 53.6022 64.5 54 64.5H58.5C59.2957 64.5 60.0587 64.1839 60.6213 63.6213C61.1839 63.0587 61.5 62.2957 61.5 61.5V37.5C61.5002 37.303 61.4615 37.1078 61.3862 36.9257C61.3109 36.7436 61.2005 36.5782 61.0612 36.4388ZM51 30.6206L56.3794 36H51V30.6206Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_5803",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s-3.491031c2f1c9c3d534889d02bc620121.svg";
export { ForwardRef as ReactComponent };